// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  APIURL: 'https://310npy7ywe.execute-api.eu-central-1.amazonaws.com', // DO NOT TOUCH THIS VARIABLE!!
  production: true, // DO NOT TOUCH THIS VARIABLE!!
  storageUrl: 'https://storageklun.blob.core.windows.net/test-public',
  companyId: '100001',
  seriesId: '',
  recaptchaKey: '6Lf57yAmAAAAAAu0Pn3TUbn74Qd16MMJnfi1730x',
  debug: false,
  debugMaterials: false,
  showStepper: true,
  enableMeasurementsV1: false,
  addScriptsOnStart: true,
  enableRoomConfiguration: false,
  placeInitialProduct: true,
  InitialTargetPosition: [0, 0, 0],
  showDetails: false,
  backgroundColor: 0xeeeeee,
  showPoweredBy: false,
  arButtonEnabled: true,
  zoomButtonsEnable: true,
  showCameraViewChangeButtons: true,
  showLockCamera: true,
  shoppingCartEnabled: true,
  layoutConfiguration: false,
  configuratorModeEnum: 'ProductConfiguration',
  hideBlueprintSelectionOnSelect: true,
  showProductBlueprintDimensions: true,
  enableConfigurationRestoration: false,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
